import React from 'react';
import PropTypes from 'prop-types';
import { MaterialIcon, Button } from '@pearsontechnology/aero-components';
import CSVDownloader from 'react-csv-downloader';

const getFilenameDate = () => (new Date()).toLocaleString('en-AU', {
  year: 'numeric',
  month: 'short',
  day: '2-digit',
  hour: '2-digit',
  minute: 'numeric',
});

function CSVDownloadButton({ appendDate, fileName, disabled, label, ...props }) {
  const displayedName = appendDate ? `${fileName}-${getFilenameDate()}` : fileName;

  const buttonEl = (
    <Button label={label} iconRight grey disabled={disabled}>
      {label}
      <MaterialIcon id="get_app" />
    </Button>
  );

  if (disabled) {
    return buttonEl;
  }

  return (
    <CSVDownloader
      {...props}
      filename={`${displayedName}.csv`}
    >
      {buttonEl}
    </CSVDownloader>
  );
}

CSVDownloadButton.propTypes = {
  label: PropTypes.string.isRequired,
  fileName: PropTypes.string,
  appendDate: PropTypes.bool,
  disabled: PropTypes.bool,
};

CSVDownloadButton.defaultProps = {
  fileName: 'export',
  appendDate: true,
};

export default CSVDownloadButton;
